import React, { useEffect, useState, useRef } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, PickListColumns, PackedOrderColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { getPackingLabels } from '../../store/actions/picker.action';
import moment from 'moment';
import DatePickerComponent from "../common/DatePickerComponent";
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import { toast } from "react-toastify";
import { getPickListMergedPdf } from '../../store/actions/batch.action';
import { commaSeparatedStringToArray } from '../../config/utils';
import ViewOrderDialog from './ViewOrderDialog';
import PackVerificationDialog from './PackVerificationDialog';
import './PickScanDialog.css';

/*istanbul ignore next */
const PickList = () => {
    let dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [packingLabels, setPackingLabels] = useState([]);
    const [needsSeparation, setNeedsSeparation] = useState(false);
    const [includePageIndex, setIncludePageIndex] = useState(false);
    const [viewDetailDetails, setViewDetailDetails] = useState({
        show: false,
        item: {}
    });
    const [packVerifyDetails, setPackVerifyDetails] = useState({
        show: false,
        item: {},
        initialLabel: ''
    });
    const [scanInput, setScanInput] = useState('');
    const [scanFeedback, setScanFeedback] = useState(null);
    const [activeTab, setActiveTab] = useState('pending');
    const scanInputRef = useRef(null);
    const scanTimerRef = useRef(null);
    const { packingLabelListStatus, packingLabelList } = useSelector((state) => state.pickerReducer);

    useEffect(() => {
        if (packVerifyDetails.show) return;
        const keepFocus = () => {
            if (scanInputRef.current && document.activeElement !== scanInputRef.current) {
                scanInputRef.current.focus();
            }
        };
        keepFocus();
        const interval = setInterval(keepFocus, 500);
        document.addEventListener('click', keepFocus);
        return () => {
            clearInterval(interval);
            document.removeEventListener('click', keepFocus);
        };
    }, [packVerifyDetails.show]);

    const playSound = (type) => {
        try {
            const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioCtx.createOscillator();
            const gainNode = audioCtx.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioCtx.destination);
            gainNode.gain.value = 0.3;
            if (type === 'success') {
                oscillator.frequency.value = 880;
                oscillator.type = 'sine';
            } else {
                oscillator.frequency.value = 300;
                oscillator.type = 'square';
            }
            oscillator.start();
            oscillator.stop(audioCtx.currentTime + 0.15);
        } catch (e) {
            // Audio not supported
        }
    };

    const processScan = (rawValue) => {
        const scannedValue = (rawValue || '').split(',')[0].trim();
        if (!scannedValue) return;
        setPackVerifyDetails({ show: true, item: {}, initialLabel: scannedValue });
        setScanFeedback({ type: 'success', message: `Loading order for "${scannedValue}"...` });
        playSound('success');
        setScanInput('');
        setTimeout(() => setScanFeedback(null), 2000);
    };

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
        startDate: moment().format('YYYY-MM-DDT00:00:00'),
        endDate: moment().format('YYYY-MM-DDT00:00:00'),
    }
    const [filterData, setfilterData] = useState(dataLoad);

    const handleAction = async (item, type) => {
        if (type === 'print') {
            setLoader(true);
            let data = commaSeparatedStringToArray(item.orderNumber);
            let payload = {
                listOrderNumber: data,
                endDate: filterData.endDate,
                startDate: filterData.startDate,
                needsSeparation: needsSeparation,
                isPrinted: true,
                includePageIndex: includePageIndex
            }
            if (data.length) {
                let mergedRes = await getPickListMergedPdf(payload);
                if (mergedRes?.data?.Status === 200) {
                    window.open(mergedRes.data.Entity);
                    toast.success('Label printed successfully');
                    setLoader(false);
                    fetchAllList();
                }
                setLoader(false);
            } else {
                toast.error('Can not reprint selected order(s) label');
                setLoader(false);
            }
        } else if (type === 'view') {
            setViewDetailDetails({
                show: true,
                item: item
            });
        }
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    useEffect(() => {
        if (packingLabelListStatus === 'PENDING') {
            setLoader(true);
        } else if (packingLabelListStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [packingLabelListStatus]);

    useEffect(() => {
        fetchAllList();
    }, [filterData.numberOfPage, filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    const fetchAllList = () => {
        let payload = {
            ...filterData,
            startDate: moment(filterData.startDate).format('YYYY-MM-DD'),
            endDate: moment(filterData.endDate).format('YYYY-MM-DD')
        };
        dispatch(getPackingLabels(payload));
    }

    const handleDateChange = (date) => {
        let dateFormat = moment(date).format('YYYY-MM-DDT00:00:00');
        let dataLoad = {
            ...filterData,
            startDate: dateFormat,
            endDate: dateFormat
        }
        setfilterData(dataLoad);
        let payload = {
            ...dataLoad,
            startDate: moment(date).format('YYYY-MM-DD'),
            endDate: moment(date).format('YYYY-MM-DD')
        }
        dispatch(getPackingLabels(payload));
    }

    useEffect(() => {
        if (packingLabelList?.packingLabelList) {
            let addlistIndex = packingLabelList.packingLabelList.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
            }));
            setPackingLabels(addlistIndex);
            if (packingLabelListStatus === 'SUCCESS') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(packingLabelList?.TotalRecords / filterData.pageSize),
                });
            }
        }
    }, [packingLabelList]);

    const handleCheckRecord = (e, type) => {
        const { checked } = e.target;
        let recordData = [...packingLabels];
        if (_.isEmpty(type)) {
            if (checked) {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: true,
                }));
                setPackingLabels(markCheck);

            } else {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: false,
                }));
                setPackingLabels(markCheck);
            }
        } else {
            recordData[type.listIndex].isChecked = checked;
            setPackingLabels(recordData);
        }
    };

    const handleMultiPrint = async () => {
        let checkedData = packingLabels.filter((item) => {
            if (item?.isChecked) {
                return item;
            }
        });
        if (checkedData.length) {
            let orderNumbers = checkedData.map(item => item.orderNumber.split(','));
            orderNumbers = orderNumbers.flat();
            let payload = {
                listOrderNumber: orderNumbers,
                endDate: filterData.endDate,
                startDate: filterData.startDate,
                needsSeparation: needsSeparation,
                isPrinted: true,
                includePageIndex: includePageIndex
            };
            setLoader(true);
            let mergedRes = await getPickListMergedPdf(payload);
            if (mergedRes?.data?.Status === 200) {
                toast.success('Labels printed successfully');
                fetchAllList();
                window.open(mergedRes.data.Entity);
                setLoader(false);
            }
            setLoader(false);
        } else {
            toast.error('Can not reprint selected order(s) label');
        }
    }

    const pendingRows = packingLabels.filter(i => (i.verifiedOrderCount || 0) < (i.orderCount || 1));
    const packedRows = packingLabels.filter(i => (i.verifiedOrderCount || 0) > 0);
    const visibleRows = activeTab === 'pending' ? pendingRows : packedRows;
    const pendingOrderQty = pendingRows.reduce((sum, i) => sum + ((i.orderCount || 0) - (i.verifiedOrderCount || 0)), 0);
    const packedOrderQty = packedRows.reduce((sum, i) => sum + (i.verifiedOrderCount || 0), 0);

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Order Packing Plan
                    <div className="pickHead mb-3 pl-3 pr-3 pt-3 zIndex2">
                        <div className="pickHead">
                            <div className="fontFix">
                                <DatePickerComponent
                                    dateField={filterData.startDate}
                                    handleDateChange={(date) => handleDateChange(date)}
                                    fieldName="ValidFrom"
                                    dateFormat="MM-dd-yyyy"
                                    showFutureDate={false}
                                />
                            </div>

                            <button disabled={!packingLabels.filter(item => item.isChecked).length || loader} className="btn cus-seconday-bg-btn showHideFilter ml-2" onClick={handleMultiPrint}>
                                <i className="fa fa-print" aria-hidden="true"></i> Print
                            </button>
                        </div>
                    </div>
                </div>

                {/* Global Scan - auto-focused input fires processScan after 150ms of no keystrokes */}
                <div className="pick-scan-bar mb-3 ml-2 mr-2">
                    <div className="pick-scan-bar-inner">
                        <i className="fa fa-barcode pick-scan-bar-icon"></i>
                        <input
                            ref={scanInputRef}
                            type="text"
                            className="pick-scan-bar-input"
                            value={scanInput}
                            onChange={(e) => {
                                const val = e.target.value;
                                setScanInput(val);
                                if (scanTimerRef.current) clearTimeout(scanTimerRef.current);
                                if (val.trim()) {
                                    scanTimerRef.current = setTimeout(() => processScan(val), 150);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (scanTimerRef.current) clearTimeout(scanTimerRef.current);
                                    processScan(scanInput);
                                }
                            }}
                            placeholder="Scan shipping label to start pack verification..."
                            autoComplete="off"
                            autoFocus
                        />
                    </div>
                </div>
                {scanFeedback && (
                    <div className={`pick-scan-feedback pick-scan-${scanFeedback.type} mb-3 ml-2 mr-2`}>
                        <span className="pick-scan-icon">
                            {scanFeedback.type === 'success' && <i className="fa fa-check-circle"></i>}
                            {scanFeedback.type === 'error' && <i className="fa fa-times-circle"></i>}
                        </span>
                        <span className="pick-scan-message">{scanFeedback.message}</span>
                    </div>
                )}

                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="d-flex fontFix mb-3">
                    <div className='fontFix mr-3'>
                        <input type="checkbox" id="needsSeparationList" checked={needsSeparation} onChange={() => setNeedsSeparation(!needsSeparation)} />
                        <label htmlFor="needsSeparationList" className="ml-2">Apply Separation on Print</label>
                    </div>
                    <div className='fontFix mr-3'>
                        <input type="checkbox" id="includePageIndex" checked={includePageIndex} onChange={() => setIncludePageIndex(!includePageIndex)} />
                        <label htmlFor="includePageIndex" className="ml-2">Print Index Page</label>
                    </div>
                </div>
                <div className="nav nav-tabs pick-tabs ml-2 mr-2 mb-2" role="tablist">
                    <div className="nav-item">
                        <button
                            type="button"
                            role="tab"
                            className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
                            onClick={() => setActiveTab('pending')}
                        >
                            Pending <span className="badge badge-secondary ml-1">{pendingOrderQty}</span>
                        </button>
                    </div>
                    <div className="nav-item">
                        <button
                            type="button"
                            role="tab"
                            className={`nav-link ${activeTab === 'packed' ? 'active' : ''}`}
                            onClick={() => setActiveTab('packed')}
                        >
                            Packed <span className="badge badge-success ml-1">{packedOrderQty}</span>
                        </button>
                    </div>
                </div>
                {activeTab === 'pending' ? (
                    <>
                        <div className="main_content_table_history">
                            <div className="tableFixHead pl-2 zIndex1">
                                {packingLabelListStatus === 'SUCCESS' && (
                                    <DataTable
                                        headers={PickListColumns}
                                        tableData={visibleRows}
                                        actionType={5}
                                        handleAction={handleAction}
                                        handleSortingColumn={handleSortingColumn}
                                        tableDataStatus={packingLabelListStatus}
                                        filterData={filterData}
                                        handleCheckRecord={handleCheckRecord}
                                        icon="print"
                                        isSelectAll={visibleRows.length > 0 && visibleRows.every(item => item.isChecked)}
                                    />
                                )}
                            </div>
                        </div>
                        <BatchPagination
                            gridData={visibleRows}
                            totalVisualRecords={visibleRows.length}
                            numberOfPage={filterData.pageSize}
                            numOfPage={numOfPage}
                            loader={loader}
                            currentPage={filterData.pageIndex}
                            totalPages={filterData.totalPages}
                            totalRecords={packingLabelList?.TotalRecords || 0}
                            setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                            setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                        />
                    </>
                ) : (
                    <div className="main_content_table_history">
                        <div className="tableFixHead pl-2 zIndex1">
                            {packingLabelListStatus === 'SUCCESS' && (() => {
                                const packedOrderRows = packedRows.flatMap((row) => {
                                    const orders = (row.verifiedOrderNumbers || '').split(',').filter(Boolean);
                                    return orders.map((orderNum, idx) => ({
                                        companySellerName: row.companySellerName,
                                        orderNumber: orderNum.trim(),
                                        statusDisplay: 'Packed',
                                        listIndex: idx,
                                        isChecked: false,
                                    }));
                                });
                                return (
                                    <DataTable
                                        headers={PackedOrderColumns}
                                        tableData={packedOrderRows}
                                        actionType={5}
                                        handleAction={(item) => setPackVerifyDetails({ show: true, item: {}, initialLabel: item.orderNumber })}
                                        handleSortingColumn={() => {}}
                                        tableDataStatus={packingLabelListStatus}
                                        filterData={filterData}
                                        handleCheckRecord={() => {}}
                                        icon="eye"
                                    />
                                );
                            })()}
                        </div>
                    </div>
                )}
            </div>
            {viewDetailDetails.show && (
                <ViewOrderDialog
                    modalClass="modalDeleteWrapper"
                    setModalShow={setViewDetailDetails}
                    modalShow={viewDetailDetails.show}
                    viewDetailDetails={viewDetailDetails}
                    filterData={filterData}
                    fetchAllList={fetchAllList}
                />
            )}
            {packVerifyDetails.show && (
                <PackVerificationDialog
                    modalClass="modalDeleteWrapper"
                    setModalShow={setPackVerifyDetails}
                    modalShow={packVerifyDetails.show}
                    packVerifyDetails={packVerifyDetails}
                    filterData={filterData}
                    fetchAllList={fetchAllList}
                    initialLabel={packVerifyDetails.initialLabel}
                />
            )}
        </main>
    );
}

export default PickList;